<template>
<b-container class="under-development-container">
	<h1>{{pageTitle}}</h1>
	<p>{{pageBody}}</p>
</b-container>
</template>


<script>
export default {
  name: 'UnderDevelopment',
  props:['pageTitle','pagebody'],
  data() {
	return {
	}
	},
	mounted() {
		if (this.$route.params.pageTitle) {
			this.pageTitle = this.$route.params.pageTitle;
		}
		if (this.$route.params.pageBody) {
			this.pageBody = this.$route.params.pageBody;
		}

	}

}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>